import { useMediaQuery } from "@mantine/hooks";
import { theme } from "../globalStyle/theme";

export const useIsMobile = (breakpoint) => {
    return useMediaQuery(`(max-width: ${theme.breakpoints[breakpoint]})`);
}; 